import { useState } from 'react'
import { CalendarCheck } from 'lucide-react'
import adminApi from '../../../services/adminApi'

const STATUS_STYLES = {
  new: 'bg-yellow-500/20 text-yellow-300',
  contacted: 'bg-blue-500/20 text-blue-300',
  closed: 'bg-green-500/20 text-green-300',
}

const ConsultationsTab = ({ consultations, onRefresh }) => {
  const [updatingId, setUpdatingId] = useState(null)

  if (!consultations) return null

  const handleStatusChange = async (id, status) => {
    try {
      setUpdatingId(id)
      await adminApi.patch(`/api/admin/corporate-consultations/${id}/status`, { status })
      onRefresh?.()
    } catch (err) {
      console.error('Failed to update status:', err)
    } finally {
      setUpdatingId(null)
    }
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-xl font-semibold text-white flex items-center gap-2">
          <CalendarCheck className="w-6 h-6" />
          Corporate Consultation Requests ({consultations.length})
        </h3>
      </div>

      {consultations.length === 0 ? (
        <div className="text-center py-16 text-gray-400">
          <CalendarCheck className="w-12 h-12 mx-auto mb-4 opacity-50" />
          <p>No corporate consultation requests yet</p>
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-white/10">
            <thead>
              <tr>
                {['Name', 'Email', 'Company', 'Phone', 'Status', 'Submitted'].map(header => (
                  <th key={header} className="px-4 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-white/10">
              {consultations.map((req) => (
                <tr key={req.id} className="hover:bg-white/5">
                  <td className="px-4 py-4 whitespace-nowrap text-sm font-medium text-white">
                    {req.name}
                  </td>
                  <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-300">
                    <a href={`mailto:${req.email}`} className="hover:text-white transition-colors">
                      {req.email}
                    </a>
                  </td>
                  <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-300">
                    {req.companyName}
                  </td>
                  <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-300">
                    <a href={`tel:${req.phone}`} className="hover:text-white transition-colors">
                      {req.phone}
                    </a>
                  </td>
                  <td className="px-4 py-4 whitespace-nowrap">
                    <select
                      value={req.status}
                      onChange={(e) => handleStatusChange(req.id, e.target.value)}
                      disabled={updatingId === req.id}
                      className={`rounded-full px-3 py-1 text-xs font-medium border-0 cursor-pointer focus:outline-none focus:ring-2 focus:ring-purple-500 ${STATUS_STYLES[req.status] || 'bg-gray-500/20 text-gray-300'}`}
                      style={{ backgroundColor: 'transparent' }}
                    >
                      <option value="new" className="bg-slate-800 text-white">New</option>
                      <option value="contacted" className="bg-slate-800 text-white">Contacted</option>
                      <option value="closed" className="bg-slate-800 text-white">Closed</option>
                    </select>
                  </td>
                  <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-300">
                    {new Date(req.createdAt).toLocaleDateString()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}

export default ConsultationsTab
